// @ts-nocheck

import React, { memo } from 'react';
import styled from 'styled-components';

import { Clock } from '../../assets/svg/common';
import { __ } from '../../i18n/l10n';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

const ClockIcon = styled(Clock)`
  width: 1.4em;
  height: 1.4em;
  font-size: 0.9em;
  margin: 0 0.7em;
`;

type MenuDesktopCalendarButtonProps = {
  connected: boolean;
  clearCalendarPreferences: () => void;
};

const MenuDesktopCalendarButton = ({ connected, clearCalendarPreferences }: MenuDesktopCalendarButtonProps) => {
  return (
    <SportsMenuListItem
      to={RoutesRedirectionFactory.getCalendarRouteConfig()}
      $margin={!connected}
      onClick={() => {
        clearCalendarPreferences();
      }}
    >
      <SportsMenuBtnContent>
        <ClockIcon />
        <SportsMenuBtnLabel $separator={connected}>{__('Upcoming matches')}</SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </SportsMenuListItem>
  );
};

export default memo<MenuDesktopCalendarButtonProps>(MenuDesktopCalendarButton);
